const activities: any[] =[
    // ---- Programme saison 2026-2027 ----
    {
        title: 'Camp de ski de fond',
        text: 'Inscriptions chez Alain Hermann',
        text2:'Camp',
        text3:'11 – 13 décembre 2026',
        img: process.env.PUBLIC_URL + 'images/club/sortie.jpg',
        link:'mailto:hermannalain@netplus.ch',
        linkText:'S\'inscrire',
        category:'All',
        date:'2026-12-11',
        end:'2026-12-13',
        place:'Vallée de Conches',
        featured:false,
    },
    {
        title: 'Sortie club',
        text: 'Rdv 9h30 à la Cambuse, dès 12h au Rôdeur (Igloo 1850)',
        text2:'Activités membres',
        text3:'16 janvier 2027',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch6.jpg',
        link:'',
        linkText:'',
        category:'All',
        date:'2027-01-16',
        end:'2027-01-16',
        place:'',
        featured:false,
    },
    {
        title: 'Assemblée générale',
        text: 'Assemblée à 17h30 à la salle communale maison Gauthier à Vex, suivie de la fondue (sur inscription)',
        text2:'Activités membres',
        text3:'16 janvier 2027',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch5.jpg',
        link:'mailto:info@mouchpaba.ch?subject=Inscription%20fondue%20AG',
        linkText:'S\'inscrire à la fondue',
        category:'All',
        date:'2027-01-16',
        end:'2027-01-16',
        place:'Vex',
        featured:false,
    },
    {
        title: 'Children / FIS / Mouch\'Paba Open',
        text: 'Sprint le samedi, classique le dimanche',
        text2:'Course',
        text3:'30 – 31 janvier 2027',
        img: process.env.PUBLIC_URL + 'images/course2027/hero.jpg',
        link:'https://www.fis-ski.com/DB/general/event-details.html?sectorcode=TM&eventid=63112&seasoncode=2027',
        linkText:'Infos FIS',
        category:'All',
        date:'2027-01-30',
        end:'2027-01-31',
        place:'',
        featured:true,
    },
    {
        title: 'Sortie membres',
        text: 'Rdv 9h30 à la Cambuse, dès 12h au Rôdeur (Igloo 1850)',
        text2:'Activités membres',
        text3:'13 février 2027',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch2.jpg',
        link:'',
        linkText:'',
        category:'All',
        date:'2027-02-13',
        end:'2027-02-13',
        place:'',
        featured:false,
    },
    {
        title: '25 ans du club',
        text: 'Programme détaillé à suivre ; journée principale le samedi 13 mars',
        text2:'Fête',
        text3:'12 – 14 mars 2027',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_15.jpg',
        link:'',
        linkText:'',
        category:'All',
        date:'2027-03-12',
        end:'2027-03-14',
        place:'',
        featured:false,
    },
    {
        title: 'Dernière sortie',
        text: 'Dernière sortie de la saison',
        text2:'Activités membres',
        text3:'10 avril 2027',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch3.jpg',
        link:'',
        linkText:'',
        category:'All',
        date:'2027-04-10',
        end:'2027-04-10',
        place:'Thyon',
        featured:false,
    },


    {
        title: 'Mouchtec',
        text: 'Le Mouch\'Tec est le groupe d\'entraînement du Mouch\'PaBa. Il est ouvert à toutes les personnes qui souhaitent découvrir le télémark ou améliorer leur technique. Actuellement, il y a plus de 35 jeunes entre 10 et 20 ans."',
        text2:'Des activités régulières ont lieu toute la saison.',
        text3:'Le Mouch\'Tec est le groupe d\'entraînement du Mouch\'PaBa. Il est ouvert à toutes les personnes qui souhaitent découvrir le télémark ou améliorer leur technique. Actuellement, il y a plus de 20 jeunes entre 10 et 20 ans.',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_5.jpg',
        link:"https://www.mouchtec.ch",
        linkText:"Plus d'informations",
        category:'All',
        date:'2026-05-01',

    },
        {
        title: 'Telemark Worldcup Finals 2025',
        text: 'La clôture de la coupe du monde avec la remise des globes aura lieu à Thyon',
        text2:'Telemark Races',
        text3:'27-30 mars 2025',
        img: process.env.PUBLIC_URL + 'images/fis2024/test3.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2025-03-31',

    },
    {
        title: 'Sortie ouverte à tous les membres du club',
        text: 'Rdv 9h30 à la Cambuse, dès 12h au Rôdeur (Igloo 1850)',
        text2:'Activités membres',
        text3:'10 janvier 2026',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch6.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2026-01-10',

    },
    {
        title: 'Assemblée générale',
        text: 'Salle bourgeoisiale Vex',
        text2:'Activités membres',
        text3:'10 janvier 2026',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch5.jpg',
        link:"mailto:amelie.reymond@gmail.com",
        linkText:"Renseignements",
        category:'All',
        date:'2026-01-10',

    },

    {
        title: 'Initiation Telemark',
        text: 'Thyon 2000 dès 10h00',
        text2:'Ouvert à tous',
        text3:'1 février 2026',
        img: process.env.PUBLIC_URL + 'images/initiations/testE.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2026-02-01',

    },
    {
        title: 'MouchPaba Race 2026',
        text: 'Piste de la Muraz',
        text2:'Ouvert à tous',
        text3:'8 février 2026',
        img: process.env.PUBLIC_URL + 'images/fis2024/test3.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2026-02-08',

    },
    {
        title: 'Sortie ouverte à tous les membres du club',
        text: 'Sortie station partenaire 4 Vallées',
        text2:'Activités membres',
        text3:'7 mars 2026',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch2.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2026-03-07',

    },
    {
        title: 'Sortie ouverte à tous les membres du club',
        text: 'Rdv 9h30 à la Cambuse, dès 12h au Rôdeur (Igloo 1850)',
        text2:'Activités membres',
        text3:'11 avril 2026',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch3.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2026-04-11',

    },
    {
        title: 'La Clandestina Ovronnaz',
        text: 'Course populaire',
        text2:'Activités membres',
        text3:'14 mars 2026',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch1.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2026-03-14',

    },
    {
        title: 'La Tzigière Grimentz',
        text: 'Course populaire',
        text2:'Activités membres',
        text3:'28 mars 2026',
        img: process.env.PUBLIC_URL + 'images/2024mouchtec/mouch2.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2026-03-28',

    },


    {
        title: 'TitleAssembly',
        text: 'Assembly_description',
        text2:'Assembly_text2',
        text3:'Assembly_text3',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_2.jpg',
        link:"mailto:amelie.reymond@gmail.com",
        linkText:"Inscriptions",
        category:'All',
        date:'2023-01-14',

    },
    {
        title: 'TitleFriend_1',
        text: 'Friend_1_description',
        text2:'Friend_1_text2',
        text3:'Friend_1_text3',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_3.jpg',
        link:"https://www.mouchtec.ch/inscription-initiation",
        linkText:"Inscriptions",
        category:'All',
        date:'2023-01-21',

    },

    {
        title: 'TitleInitiation',
        text: 'Initiation_description',
        text2:'Initiation_text2',
        text3:'Initiation_text3',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_15.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:'2023-02-05',

    },

    {
        title: 'MembreSortie_18_02_2023',
        text: 'MembreSortie_18_02_2023_description',
        text2:'MembreSortie_18_02_2023_text2',
        text3:'MembreSortie_18_02_2023_text3',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_14.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:"2023-02-18"

    },
    {
        title: 'Mouch Paba Race',
        text: 'Course enfants et populaire',
        text2:'15 février 2025',
        text3:'Inscription jusqu\'au 12 février 18h00. Lien d\'inscription dans le programme.  ',
        img: process.env.PUBLIC_URL + 'images/STC2023/telekids2.jpg',
        link:"/docs/ProgrammeChildren2025.pdf",
        linkText:"Programme de la course",
        category:'All',
        date:"2025-02-15"

    },
    {
        title: 'Course FIS et enfants',
        text: 'Course franco-Suisse 2024.',
        text2:'07 janvier 2024',
        text3:'Rdv 08h00 aux Masses',
        img: process.env.PUBLIC_URL + 'images/STC2023/MS1.jpg',
        link:"https://forms.office.com/r/2ijvYeG0wM",
        linkText:"Inscription",
        category:'All',
        date:"2024-01-07"

    },
    {
        title: 'Sortie membre',
        text: 'Sortie ouverte à tous les membres du club.',
        text2:'13 janvier 2024',
        text3:'Rdv 9h30 à la Cambuse, dès 12h au Rôdeur (Igloo 1850)',
        img: process.env.PUBLIC_URL + 'images/MP_Reymond_1.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:"2024-01-13"

    },
    {
        title: 'AG',
        text: 'Assemblée générale du club, suivi d\'une fondue',
        text2:'13 janvier 2024',
        text3:'Rdv 18h00 maison Gauthier Vex',
        img: process.env.PUBLIC_URL + 'images/club/test.jpg',
        link:"mailto:amelie.reymond@gmail.com",
        linkText:"Inscription AG",
        category:'All',
        date:"2024-01-13"

    },
    {
        title: 'Test Télémark et Initiation',
        text: 'Ouvert à tous, le test de télémark est la première occasion de découvrir la discipline télémark.',
        text2:'4 février 2024',
        text3:'Dès 10h00 sur la place de Thyon 2000',
        img: process.env.PUBLIC_URL + 'images/club/sortie.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:"2024-02-04"

    },
    {
        title: 'Sortie membre',
        text: 'Sortie ouverte à tous les membres du club.',
        text2:'10 février 2024',
        text3:'Rdv 9h30 à la Cambuse, dès 12h au Rôdeur (Igloo 1850)',
        img: process.env.PUBLIC_URL + 'images/MP_Reymond_1.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:"2024-02-10"

    },
    {
        title: 'Sortie membre',
        text: 'Sortie ouverte à tous les membres du club.',
        text2:'9 mars 2024',
        text3:'Rdv 9h30 à la Cambuse, dès 12h au Rôdeur (Igloo 1850)',
        img: process.env.PUBLIC_URL + 'images/MP_Reymond_2.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:"2024-03-09"

    },
    {
        title: 'The last of the season',
        text: 'Sortie ouverte à tous les membres du club.',
        text2:'13 avril 2024',
        text3:'Rdv 9h30 à la Cambuse, dès 12h au Rôdeur (Igloo 1850)',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_15.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:"2024-04-13"

    },
    {
        title: 'TitleFriend_2',
        text: 'Friend_2_description',
        text2:'Friend_2_text2',
        text3:'Friend_2_text3',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_9.jpg',
        link:"https://www.mouchtec.ch/inscription-initiation",
        linkText:"Inscriptions",
        category:'All',
        date:"2023-02-04"

    },
    {
        title: 'MembreSortie_18_03_2023',
        text: 'MembreSortie_18_03_2023_description',
        text2:'MembreSortie_18_03_2023_text2',
        text3:'MembreSortie_18_03_2023_text3',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_12.jpg',
        link:"",
        linkText:"",
        category:'All',
        date:"2023-03-18"

    },

    {
        title: 'TitleFriend_3',
        text: 'Friend_3_description',
        text2:'Friend_3_text2',
        text3:'Friend_3_text3',
        img: process.env.PUBLIC_URL + 'images/mouchtec/mouch_11.jpg',
        link:"https://www.mouchtec.ch/inscription-initiation",
        linkText:"Inscriptions",
        category:'All',
        date:"2023-03-11"

    },
    {
        title: 'TitleSwisschamps',
        text: 'Swisschamps_description',
        text2:'Swisschamps_text2',
        text3:'Swisschamps_text3',
        img: process.env.PUBLIC_URL + 'images/romain.jpg',
        link:"/Swisschamps",
        linkText:"Plus d'informations",
        category:'All',
        date:"2023-04-02"

    },














];


export default activities;
